export var ChartIntervalEnum;
(function (ChartIntervalEnum) {
    ChartIntervalEnum["DAY"] = "DAY";
    ChartIntervalEnum["WEEK"] = "WEEK";
    ChartIntervalEnum["MONTH"] = "MONTH";
    ChartIntervalEnum["AUTO"] = "AUTO";
})(ChartIntervalEnum || (ChartIntervalEnum = {}));
//# sourceMappingURL=chart-interval.enum.js.map